import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import babyStockFootage from '@/assets/baby-stock-footage.mp4';

export const Hero = () => {
    return (
        <div className="w-full">
            {/* Hero section - Background Video */}
            <section className="fixed top-0 left-0 w-full h-screen overflow-hidden">
                {/* Background video - full viewport coverage */}
                <video 
                    autoPlay 
                    muted 
                    loop 
                    playsInline
                    className="absolute inset-0 w-full h-full object-cover"
                >
                    <source src={babyStockFootage} type="video/mp4" />
                </video>
                
                {/* Subtle overlay to enhance video visibility without strong purple gradient */}
                <div className="absolute inset-0" style={{ 
                    background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.2))',
                    mixBlendMode: 'multiply'
                }}></div>
                <div className="absolute inset-0 bg-gradient-to-b from-blue-500/20 to-sky-500/20"></div>
                <div className="absolute inset-0 bg-pattern opacity-30"></div>
            </section>
            
            {/* Hero content - separate positioned element */}
            <section className="relative w-full h-screen z-10">
                <div className="h-full flex flex-col justify-center items-center text-center px-6">
                    <Badge variant="outline" className="bg-white/30 text-white mb-6 backdrop-blur-sm border-white/30 px-4 py-2">
                        Revolutionary Smart Diaper Technology
                    </Badge>
                    
                    <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold mb-8 text-white leading-tight max-w-5xl drop-shadow-md">
                        The Smart Diaper That Gives Parents Peace of Mind
                    </h1>
                    
                    <p className="text-white text-xl max-w-2xl mx-auto mb-12 drop-shadow-sm font-medium">
                        BerryBabies' innovative sensor technology monitors your baby's comfort and health, 
                        alerting you instantly when a change is needed.
                    </p>
                    
                    <div className="flex flex-col sm:flex-row gap-5 justify-center">
                        <Button size="lg" className="bg-gradient-to-r from-pink-500 to-violet-500 hover:from-pink-600 hover:to-violet-600 text-white btn-baby text-lg px-8 py-6 shadow-lg border-0">
                            Shop Now
                        </Button>
                        <Button size="lg" variant="outline" className="backdrop-blur-sm border-white/70 text-white hover:bg-white/20 btn-baby text-lg px-8 py-6 shadow-lg">
                            Learn More
                        </Button>
                    </div>
                </div>
            </section>
        </div>
    );
};